// extracted by mini-css-extract-plugin
export default {"closeBtn":"CrossButton_closeBtn__MAlXD"};